<template>
  <div>
    <div v-if="!changePwd">
      <div v-if="dailogShow" class="mask" @click="dailogShow = false"></div>
      <!-- 绑定手机号 -->
      <div v-if="dailogShow" class="login_box">
        <!-- 绑定手机号成功 -->
        <div v-if="getPhoneYes">
          <div class="mask"></div>
          <div class="new_pws">
            <div>
              <i class="el-icon-success"></i>
              <div>{{ success }}</div>
            </div>
            <div class="tips_info">
              {{ new_psd_time }}s 后自动跳转到个人中心
            </div>
          </div>
        </div>
        <div class="login_tit">
          <div>
            {{ login_tit }}
          </div>
        </div>
        <!-- 绑定手机号弹框 -->
        <div v-if="bangding" class="login_body">
          <el-form
            :model="yanzheng"
            :rules="yanzheng_rules"
            ref="yanzheng_ruleForm"
            class="demo-ruleForm"
          >
            <!-- 手机号 -->
            <div class="level">
              <el-form-item prop="phone">
                <div class="phone_box">
                  <div>+86</div>
                  <el-input
                    v-model="yanzheng.phone"
                    placeholder="请输入要绑定的手机号码"
                  ></el-input>
                </div>
              </el-form-item>
            </div>
            <!-- 验证码 -->
            <div class="level">
              <el-form-item prop="yzm" class="yzm_box">
                <el-input
                  type="password"
                  placeholder="请输入验证码"
                  v-model="yanzheng.yzm"
                ></el-input>
                <button
                  :class="{ yzm_btn_no: disabled2 }"
                  :disabled="disabled2"
                  class="yzm_btn"
                  @click="getYzm"
                >
                  {{ btnTitle }}
                </button>
              </el-form-item>
            </div>
            <div @click="submitForm('yanzheng_ruleForm', 0)" class="login_btn">
              完 成
            </div>
          </el-form>
        </div>
        <!-- 更改手机号弹框 -->
        <div v-if="genggai" class="login_body">
          <div v-if="yesEidt">
            <div class="mask"></div>
            <!-- 确认更改弹框 -->
            <div class="yesEditDailog">
              <div class="edit_tit">
                更换手机号码
              </div>
              <div class="edit_desc">
                更换手机号码前，需要将当前的绑定关系解除，请确认是否更换
              </div>
              <div class="edit_btn">
                <div @click="querenEdit">确认</div>
                <div @click="yesEidt = false">取消</div>
              </div>
            </div>
          </div>
          <el-form
            :model="yanzheng"
            :rules="yanzheng_rules"
            ref="yanzheng_ruleForm"
            class="demo-ruleForm"
          >
            <!-- 手机号 -->
            <div class="level">
              <el-form-item prop="phone">
                <div class="phone_box">
                  <div>+86</div>
                  <el-input disabled v-model="yanzheng.phone"></el-input>
                </div>
              </el-form-item>
            </div>
            <div class="level">
              <el-form-item prop="phone">
                <el-input
                  v-model="oldPsw"
                  placeholder="请补全原手机号的完整密码"
                ></el-input>
              </el-form-item>
            </div>
            <div @click="editPhoneYes" class="login_btn">
              完 成
            </div>
          </el-form>
        </div>
        <!-- 新手机号弹框 -->
        <div v-if="newPhone" class="login_body">
          <el-form
            :model="yanzheng"
            :rules="yanzheng_rules"
            ref="yanzheng_ruleForm"
            class="demo-ruleForm"
          >
            <!-- 手机号 -->
            <div class="level">
              <el-form-item>
                <div class="phone_box">
                  <div>+86</div>
                  <el-input disabled v-model="yanzheng.phone"></el-input>
                </div>
              </el-form-item>
            </div>
            <!-- 新手机号 -->
            <div class="level">
              <el-form-item prop="newPhone">
                <el-input
                  v-model="yanzheng.newPhone"
                  placeholder="请输入新的手机号码"
                ></el-input>
              </el-form-item>
            </div>
            <!-- 验证码 -->
            <div class="level">
              <el-form-item prop="yzm" class="yzm_box">
                <el-input
                  type="password"
                  placeholder="请输入验证码"
                  v-model="yanzheng.yzm"
                ></el-input>
                <button
                  :class="{ yzm_btn_no: disabled2 }"
                  :disabled="disabled2"
                  class="yzm_btn"
                  @click="getYzm"
                >
                  {{ btnTitle }}
                </button>
              </el-form-item>
            </div>
            <div @click="submitForm('yanzheng_ruleForm', 1)" class="login_btn">
              完 成
            </div>
          </el-form>
        </div>
      </div>
      <!-- 手机号码 -->
      <!-- <div class="anquan_box">
        <div class="anquan_left">
          <img src="../../../assets/img/home/cion_sjh.png" alt />
          <div class="mima_tit">{{ phonetitle }}</div>
          <div class="mima_tip">
            可以用来找回密码与修改密码
          </div>
        </div>
        <div class="anquan_rt">
          <div
            v-if="phonetitle == '绑定手机号'"
            class="anquan_btn"
            @click="goBangding"
          >
            绑定
          </div>
          <div v-else class="anquan_btn" @click="goEditPhone">更改</div>
        </div>
      </div> -->
      <!-- 登录密码 -->
      <div class="anquan_box">
        <div class="anquan_left">
          <img src="../../../assets/img/home/icon_mm.png" alt />
          <div class="mima_tit">密码</div>
          <div class="mima_tip">可以保护账号安全登录验证</div>
        </div>
        <div class="anquan_rt">
          <div class="anquan_btn" @click="changePwd = true">更改</div>
        </div>
      </div>
    </div>
    <!-- 更改密码部分 -->
    <ChangePwd v-else @getData="getData"></ChangePwd>
  </div>
</template>
<script>
import ChangePwd from "@/components/personal/zhanghu/changePwd.vue";
export default {
  components: {
    ChangePwd,
  },
  data() {
    return {
      // 更改密码部分
      changePwd: false,
      // 原始密码
      oldPsw: "",
      // 修改弹框
      dailogShow: false,
      // 绑定成功提示框
      getPhoneYes: false,
      // 绑定弹框
      bangding: false,
      // 更改弹框
      genggai: false,
      // 确认更改提示框
      yesEidt: false,
      // 新手机号弹框
      newPhone: false,
      success: "",
      phonetitle: "绑定手机号",
      phoneStatus: "绑定",
      login_tit: "绑定手机号码",
      yanzheng: {
        phone: "",
        yzm: "",
        newPhone: "",
      },
      new_psd_time: "",
      btnTitle: "获取验证码",
      disabled2: false,
      // 验证码验证规则
      yanzheng_rules: {
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        newPhone: [
          { required: true, message: "请输入新手机号码", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        yzm: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    getData(data) {
      this.changePwd = data
    },
    // 点击绑定手机号
    goBangding() {
      this.dailogShow = true;
      this.bangding = true;
      this.yanzheng = {};
    },
    // 获取验证码
    getYzm() {
      this.time = 60;
      this.timer = setInterval(() => {
        if (this.time == 0) {
          clearInterval(this.timer);
          this.btnTitle = "获取验证码";
          this.disabled2 = false;
        } else {
          this.btnTitle = this.time + "秒后重试";
          // this.btnTitle = "获取验证码" + "(" + this.time + ")";
          this.disabled2 = true;
          this.time--;
        }
      }, 1000);
    },
    // 更改手机号
    goEditPhone() {
      this.newPhone = false;
      this.yesEidt = false;
      this.bangding = false;
      this.dailogShow = true;
      // this.yanzheng = {};
      this.genggai = true;
      this.login_tit = "更改手机号";
    },
    // 完成更改手机号按钮
    editPhoneYes() {
      if (!this.oldPsw) {
        this.$message.error("请输入原始密码！");
        return;
      }
      // 确认更改提示框显示
      this.yesEidt = true;
    },
    // 确认更改
    querenEdit() {
      this.newPhone = true;
      this.dailogShow = true;
      this.genggai = false;
      this.yanzheng.yzm = "";
    },
    // 登录
    submitForm(formName, type) {
      console.log(type);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (type == 0) {
            console.log("绑定账号成功");
            this.new_psd_time = 3;
            this.dailogShow = true;
            this.getPhoneYes = true;
            this.success = "绑定成功";
            this.timer2 = setInterval(() => {
              if (this.new_psd_time == 0) {
                clearInterval(this.timer2);
                // this.getPhone = false;
                this.login_show = 0;
                this.dailogShow = false;
                this.getPhoneYes = false;
                this.phonetitle = this.yanzheng.phone;
              } else {
                this.new_psd_time--;
                // console.log(this.new_psd_time);
              }
            }, 1000);
          } else if (type == 1) {
            console.log("新手机号成功");
            this.new_psd_time = 3;
            this.dailogShow = true;
            this.getPhoneYes = true;
            this.success = "更改成功";
            this.timer2 = setInterval(() => {
              if (this.new_psd_time == 0) {
                clearInterval(this.timer2);
                // this.getPhone = false;
                this.login_show = 0;
                this.dailogShow = false;
                this.getPhoneYes = false;
                this.phonetitle = this.yanzheng.newPhone;
              } else {
                this.new_psd_time--;
                // console.log(this.new_psd_time);
              }
            }, 1000);
          }
        } else {
          if (type == 0) {
            console.log("绑定账号失败");
          } else if (type == 1) {
            // 账号验证
            console.log("账号验证失败");
          }
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less">
.yesEditDailog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 668;
  width: 291px;
  height: 175px;
  background: #fff;
  border-radius: 10px;
  color: #343434;
  text-align: center;
  overflow: hidden;
  .edit_tit {
    font-size: 18px;
    margin: 20px 0;
  }
  .edit_desc {
    width: 237px;
    margin: 0 auto;
    font-size: 14px;
    // margin-bottom: 30px;
    line-height: 1.8;
  }
  .edit_btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 45px;
    line-height: 45px;
    border-top: 1px solid #cccccc;
    display: flex;
    align-items: center;
    font-size: 16px;
    div {
      cursor: pointer;
      width: 50%;
    }
    div:nth-child(1) {
      background-color: #029aff;
      color: #fff;
    }
    div:nth-child(2) {
      color: #666666;
    }
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.6;
  z-index: 667;
}
.tip_box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 200px;
  height: 150px;
  background-color: #fff;
  border-radius: 10px;
  padding: 15px 20px;
  box-sizing: border-box;
  text-align: center;
  .el-icon-error {
    color: #e7201a;
    font-size: 30px;
  }
  .tips_info {
    width: 140px;
    margin: 10px auto;
    line-height: 1.5;
  }
  .tips_info2 {
    width: 160px;
    margin: 10px auto;
    line-height: 1.5;
  }
  .tips_btn {
    font-size: 16px;
    color: #4296f2;
    text-align: center;
    height: 37px;
    line-height: 37px;
    border-top: 1px solid #eaeaea;
    cursor: pointer;
  }
}

.anquan_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  padding: 0 30px;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(242, 242, 242, 1);
  .anquan_left {
    display: flex;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    > div {
      display: flex;
      align-items: center;
    }
    .mima_tit {
      font-size: 18px;
      color: #343434;
      margin-right: 15px;
    }
    .mima_tip {
      font-size: 14px;
      color: #ff0001;
      // margin-top: 5px;
    }
  }
  .anquan_rt {
    .anquan_btn {
      font-size: 18px;
      color: #029aff;
      cursor: pointer;
    }
  }
}
.login_box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 668;
  width: 400px;
  height: 400px;
  background-color: #fff;
  border-radius: 10px;
  // display: none;
  // overflow: hidden;
  .login_tit {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    height: 63px;
    line-height: 45px;
    border-bottom: 1px solid #cacaca;
    padding: 0 20px;
    padding-top: 5px;
    box-sizing: border-box;
    div:nth-child(1) {
      font-size: 20px;
      color: #4195f2;
    }
    div:nth-child(2) {
      font-size: 14px;
      color: #4296f2;
    }
  }
  .login_body {
    padding: 25px;
    box-sizing: border-box;
    .level {
      margin-bottom: 30px;
      .forget {
        font-size: 12px;
        color: #4296f2;
        float: right;
        cursor: pointer;
      }
      .phone_box {
        display: flex;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 4px;
        padding: 0 20px;
        box-sizing: border-box;
        div {
          font-size: 14px;
          color: #4195f2;
        }
        .el-input__inner {
          border: none !important;
        }
      }
      .yzm_box {
        position: relative;
        // display: flex;
        .yzm_btn {
          position: absolute;
          top: 50%;
          right: 15px;
          height: 90%;
          transform: translateY(-50%);
          color: #4296f2;
          font-size: 14px;
          border: none;
          background-color: #fff;
          cursor: pointer;
        }
      }
    }
    .login_btn {
      position: absolute;
      left: 50%;
      bottom: 30px;
      transform: translate(-50%);
      width: 270px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      color: #fff;
      font-size: 20px;
      background-color: #4195f2;
      border-radius: 25px;
      cursor: pointer;
    }
    .yzm_btn_no {
      cursor: not-allowed !important;
    }
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000000;
    opacity: 0.2;
    z-index: 1;
  }
  .tip_box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    width: 200px;
    height: 150px;
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 20px;
    box-sizing: border-box;
    text-align: center;
    .el-icon-error {
      color: #e7201a;
      font-size: 30px;
    }
    .tips_info {
      width: 140px;
      margin: 10px auto;
      line-height: 1.5;
    }
    .tips_info2 {
      width: 160px;
      margin: 10px auto;
      line-height: 1.5;
    }
    .tips_btn {
      font-size: 16px;
      color: #4296f2;
      text-align: center;
      height: 37px;
      line-height: 37px;
      border-top: 1px solid #eaeaea;
      cursor: pointer;
    }
  }
  .tip_box2 {
    height: 130px;
  }
  .new_pws {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 770;
    width: 200px;
    height: 82px;
    background-color: #fff;
    border-radius: 10px;
    text-align: center;
    padding-top: 15px;
    box-sizing: border-box;
    > div:nth-child(1) {
      display: flex;
      align-items: center;
      justify-content: center;
      .el-icon-success {
        font-size: 28px;
        color: #4195f2;
        margin-right: 10px;
      }
      span {
        font-size: 14px;
        color: #000;
      }
    }

    > div:nth-child(2) {
      color: #4195f2;
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
</style>
